const initialState = {
  isLoading: false,
  totalRegistros: 0,
  totvsSubgrupo: [],
  open: false,
  id: 0,
  codigo: '',
  descricao: '',
  idLoja: '',
  page: 0,
  limit: 10,
  order: 'nome',
  direction: 'asc',
  term: ''
}

export function totvsSubgrupo(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_TOTVS_SUBGRUPO':
      return {
        ...state,
        totvsSubgrupo: action.totvsSubgrupo,
        totalRegistros: action.totalRegistros
      }
    case 'TOTVS_SUBGRUPO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.id,
        codigo: action.codigo,
        descricao: action.descricao,
        idLoja: action.idLoja
      }
    case 'TOTVS_SUBGRUPO_UPDATED':
      return state
    case 'TOTVS_SUBGRUPO_CLEAR':
      return {
        ...initialState,
        page: state.page,
        limit: state.limit,
        order: state.order,
        direction: state.direction,
        term: state.term
      }
    case 'TOTVS_SUBGRUPO_CLEAR_ALL':
      return {
        ...state,
        totvsSubgrupo: []
      }
    case 'TOTVS_SUBGRUPO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'TOTVS_SUBGRUPO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'TOTVS_SUBGRUPO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
